/** @format */
import Master from '../Layouts/Master';
import ErrorMessage from '../../Shared/Components/ErrorMessage';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import useApi from '../../Shared/hooks/api/Index';
import { error, success } from '../../Shared/Components/Toast';

const validationSchema = Yup.object().shape({
	name: Yup.string()
		.required('عنوان الزامی است')
		.max(190, 'عنوان نمیتواند بیشتر از 190 کاراکتر باشد'),
	gender: Yup.number()
		.typeError('انتخاب جنسیت الزامی است')
		.required('انتخاب جنسیت الزامی است'),
});

const CreateField = () => {
	const navigate = useNavigate();
	const [submitFormLoading, setSubmitFormLoading] = useState(false);

	const onSubmitForm = async (values, setSubmitting) => {
		setSubmitFormLoading(true);

		await useApi.post(
			'/sport-field',
			values,
			(res) => {
				success('رشته با موفقیت ایجاد شد');
				navigate('/panel/sport-field', { replace: true });
			},
			(err) => {
				setSubmitFormLoading(false);
				error('خطایی در ثبت اطلاعات پیش آمده است.');
			},
		);
	};

	return (
		<Master>
			<Formik
				initialValues={{
					name: '',
					gender: '',
				}}
				onSubmit={(values, { setSubmitting }) => {
					onSubmitForm(values, setSubmitting);
				}}
				validationSchema={validationSchema}>
				{({
					values,
					errors,
					handleChange,
					handleSubmit,
					isSubmitting,
					setFieldValue,
				}) => (
					<form onSubmit={handleSubmit}>
						<div className='row border rounded p-2 mt-3'>
							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group '>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>عنوان رشته</label>
										<input
											name='name'
											value={values.name}
											onChange={handleChange}
											type='text'
											className='form-control'
										/>
										<ErrorMessage error={errors.name} />
									</div>
								</div>
							</div>
							<div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
								<div className='form-group '>
									<div className='d-flex flex-column mt-1 mx-2'>
										<label>جنسیت</label>
										<select
											className='form-control'
											name='gender'
											value={values.gender}
											onChange={handleChange}>
											<option value='0'>هردو</option>
											<option value='1'>مرد</option>
											<option value='2'>زن</option>
										</select>
										<ErrorMessage error={errors.gender} />
									</div>
								</div>
							</div>
							<div className='col-12'>
								<button className='btn btn-info btn-sm f-14'>
									{submitFormLoading ? (
										<div
											className='spinner-border spinner-border-sm text-white mb-1'
											role='status'></div>
									) : (
										'ثبت رشته'
									)}
								</button>
							</div>
						</div>
					</form>
				)}
			</Formik>
		</Master>
	);
};

export default CreateField;
